import { z } from 'zod';

export const getEnglishIqResultV2RequestSchema = z.object({
  shareId: z
    .string()
    .min(6)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/u),
});

export type IGetEnglishIqResultV2Request = z.infer<typeof getEnglishIqResultV2RequestSchema>;
